import React, { useEffect, useState } from 'react';
import { StepItem } from '@/Components/shadcn/stepper';
import { StepMapperProps } from './StepMappers';

interface ModifyRecruitmentStepperProps {
    steps: string[];
    stepMapper: (props: StepMapperProps) => React.JSX.Element;
    containerRef?: React.RefObject<HTMLDivElement | null>;
}

function ModifyRecruitmentStepper({ steps, stepMapper: StepMapper, containerRef }: ModifyRecruitmentStepperProps) {
    const [activeStep, setActiveStep] = useState(0);
    const [completed, setCompleted] = useState<Array<boolean>>(Array.from({ length: steps.length }, () => false));

    const handleStep = (step: number) => () => {
        if (completed[step]) {
            setCompleted((prevState) => {
                const next = [...prevState];
                for (let i = activeStep; i >= step; i -= 1) {
                    next[i] = false;
                }
                return next;
            });
            setActiveStep(step);
        }
    };

    useEffect(() => {
        containerRef?.current?.scrollTo(0, 0);
    }, [activeStep]);

    const handleNext = () => {
        setCompleted((prevState) => {
            const next = [...prevState];
            next[activeStep] = true;
            return next;
        });
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setCompleted((prevState) => {
            const next = [...prevState];
            next[activeStep] = false;
            next[activeStep - 1] = false;
            return next;
        });
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <div className="mt-12 flex flex-col gap-2">
            <div className="flex items-center" data-cy="stepper">
                {steps.map((label, index) => {
                    const isCompleted = completed[index];
                    const isActive = activeStep === index;
                    const isFinished = isCompleted || isActive;

                    return (
                        <StepItem
                            key={label}
                            label={label}
                            isFinished={isFinished}
                            isInteractive={isCompleted}
                            hasLeftConnector={index > 0}
                            hasRightConnector={index < steps.length - 1}
                            leftConnectorCompleted={completed[index - 1] ?? false}
                            rightConnectorCompleted={isCompleted}
                            onClick={handleStep(index)}
                        />
                    );
                })}
            </div>
            <StepMapper activeStep={activeStep} handleNext={handleNext} handleBack={handleBack} />
        </div>
    );
}
export default ModifyRecruitmentStepper;
